import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { dsI18n, getCommonButtonTypeDefault, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { ExternalIcon } from '@skatteetaten/ds-icons';
import { Spinner } from '@skatteetaten/ds-progress';
import './styles.css';


var styles = {
    "button": "MegaButton-module_button__TqRpT",
    "icon": "MegaButton-module_icon__K5ifl",
    "hide": "MegaButton-module_hide__l68ET",
    "spinner": "MegaButton-module_spinner__VLuPe"
};

const MegaButton = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, spinnerTitle, accessKey, disabled, href, type = getCommonButtonTypeDefault(), ariaDescribedby, hasSpinner, isExternal, onBlur, onClick, onFocus, children }, ref)=>{
    const { t } = useTranslation('ds_buttons', {
        i18n: dsI18n
    });
    const Tag = href !== undefined ? 'a' : 'button';
    const hideClassName = hasSpinner ? styles.hide : '';
    return /*#__PURE__*/ jsxs(Tag, {
        ref: ref,
        id: id,
        className: `${styles.button} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        href: href,
        accessKey: accessKey,
        disabled: disabled,
        type: href !== undefined ? undefined : type,
        "aria-describedby": ariaDescribedby,
        role: href ? 'button' : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        children: [
            /*#__PURE__*/ jsx("span", {
                className: hideClassName,
                children: children
            }),
            isExternal && /*#__PURE__*/ jsx(ExternalIcon, {
                className: `${styles.icon} ${hideClassName}`.trim(),
                ariaLabel: t('shared.ExternalIcon')
            }),
            hasSpinner && /*#__PURE__*/ jsx(Spinner, {
                className: styles.spinner,
                color: disabled ? 'black' : 'white',
                size: 'large',
                hideTitle: true,
                children: spinnerTitle
            })
        ]
    });
});
MegaButton.displayName = 'MegaButton';

export { MegaButton };
